<style>
.bg-primary {
  background-color: #2b4e8a !important;
}
.browse {
  background-color: #0d86ff;
  color: white;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center"
    >
      PPAK
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto"
        @click="$router.go(-1)"
        >Kembali</Button
      >
    </div>
    <!-- <div class="card-header bg-white text-muted h4">Tambah</div> -->
    <form id="form-data" @submit.prevent="postData">
      <div class="card-body">
        <!-- Form Tambah Workshop -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">PPAK</div>
          <div class="card-body" id="coba">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Nama</label>
                <input
                  type="text"
                  required
                  class="form-control"
                  placeholder="Masukkan Nama RPL"
                  v-model="formData.namaRpl"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="level" class="font-weight-bold">Level</label>

                <multiselect
                  label="namaLevel"
                  placeholder="Pilih Level"
                  @input="(value) => updateSelect(value)"
                  v-model="modelLevelPeruntukan"
                  required
                  id="selectlevel"
                  :options="levelPeruntukan"
                ></multiselect>
                <div class="text-danger" v-show="validation.level">
                  Level Harus Dipilih
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kapasitas" class="font-weight-bold"
                  >Kapasitas</label
                >
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  id="kapasitas"
                  placeholder="Masukkan Kapasitas"
                  v-model="formData.kapasitas"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label for="sisa" class="font-weight-bold">Sisa</label>
                <input
                  type="text"
                  class="form-control"
                  id="sisa"
                  placeholder="Terisi Otomatis"
                  v-model="formData.kapasitas"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Tambah Workshop -->

        <div class="card border-0 shadow p-2" id="divinstruktur">
          <div class="card-header bg-white text-muted h4">Instruktur RPL</div>
          <div class="card-body">
            <div
              class="form-row"
              v-for="(input, k) in formData.instrukturSertifikasiRplRequest"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="mata_uji" class="font-weight-bold"
                  >Instruktur</label
                >
                <multiselect
                  label="nama"
                  placeholder="Pilih Instruktur"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihInstruktur(value, k)"
                  :options="instruktur"
                ></multiselect>
                <div class="text-danger" v-if="input.invalid_instruktur">
                  Instruktur Harus Dipilih.
                </div>
              </div>
              <div class="col-1 d-flex align-items-center mt-2">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add(k)"
                  v-show="
                    k == formData.instrukturSertifikasiRplRequest.length - 1
                  "
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="deleteInstruktur(input.idInstrukturSertifikasiRpl, k)"
                  v-show="
                    k ||
                    (!k && formData.instrukturSertifikasiRplRequest.length > 1)
                  "
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Mata Ujian -->
        <div class="card border-0 shadow p-2" id="divmatauji">
          <div class="card-header bg-white text-muted h4">Mata Ujian</div>
          <div class="card-body">
            <form>
              <div
                class="form-row"
                v-for="(input, k) in formData.sertifikasiRplMataUjiRequest"
                :key="k"
              >
                <div class="form-group col-md-10">
                  <label for="mata_uji" class="font-weight-bold"
                    >Mata Ujian</label
                  >
                  <multiselect
                    label="namaMataUji"
                    placeholder="Pilih Mata Uji"
                    v-model="input.modelMultiSelect"
                    required
                    @input="(value) => pilihMataUji(value, k)"
                    :options="mataUji"
                  ></multiselect>
                  <div class="text-danger" v-if="input.invalid_mata_uji">
                    Mata Uji Harus Dipilih.
                  </div>
                </div>
                <div class="col-2 d-flex align-items-center mt-2">
                  <div
                    class="btn btn-sm btn-success ml-2"
                    @click="addss(k)"
                    v-show="
                      k == formData.sertifikasiRplMataUjiRequest.length - 1
                    "
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2"
                    @click="removess(k)"
                    v-show="
                      k ||
                      (!k && formData.sertifikasiRplMataUjiRequest.length > 1)
                    "
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--End Form Mata Ujian -->

        <!-- Form Biaya RPL -->
        <div class="card border-0 shadow p-2" id="divmatauji">
          <div class="card-header bg-white text-muted h4">Biaya RPL</div>
          <div class="card-body">
            <form>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for class="font-weight-bold">Biaya Pendaftaran</label>
                  <div class="input-group mb-3">
                    <vue-autonumeric
                      required
                      class="form-control"
                      :options="{
                        minimumValue: '0',
                      }"
                      v-model="formData.biaya"
                    ></vue-autonumeric>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for class="font-weight-bold">Biaya Per Mata Uji</label>
                  <div class="input-group mb-3">
                    <vue-autonumeric
                      required
                      class="form-control"
                      :options="{
                        minimumValue: '0',
                      }"
                      v-model="formData.biayaPerMataUji"
                    ></vue-autonumeric>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--End Form Biaya RPL -->

        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2" id="divdokumen">
          <div class="card-header bg-white text-muted h4">
            Dokumen Persyaratan
          </div>
          <div class="card-body">
            <div
              class="form-row"
              v-for="(input,
              k) in formData.dokumenPendukungSertifikasiRplRequest"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="kode_dok" class="font-weight-bold">Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumen(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div class="text-danger" v-if="input.invalid_dokumen">
                  Dokumen Harus Dipilih.
                </div>
              </div>

              <div class="col-2 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="adds(k)"
                  v-show="
                    k ==
                    formData.dokumenPendukungSertifikasiRplRequest.length - 1
                  "
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="removes(k)"
                  v-show="
                    k ||
                    (!k &&
                      formData.dokumenPendukungSertifikasiRplRequest.length > 1)
                  "
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Dokumen Upload -->

        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2" id="divpenerbitan">
          <div class="card-header bg-white text-muted h4">
            Dokumen Persyaratan Penerbitan Sertifikat
          </div>
          <div class="card-body">
            <!-- <form> -->
            <div
              class="form-row"
              v-for="(input, k) in formData.dokumenPersyaratanSertifikat"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="nama_dok" class="font-weight-bold">Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumenPenerbitan(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div class="text-danger" v-if="input.invalid_dokumen">
                  Dokumen Pendukung Harus Dipilih.
                </div>
              </div>

              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok_sertifikat(k)"
                  v-show="k == formData.dokumenPersyaratanSertifikat.length - 1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="remove_dok_sertifikat(k)"
                  v-show="
                    k ||
                    (!k && formData.dokumenPersyaratanSertifikat.length > 1)
                  "
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- End Form Dokumen Upload -->

        <div class="">
          <div class="card-body pl-0">
            <div class="row">
              <CCol sm="12">
                <label for class="font-weight-bold">Status</label>
                <br />
                <div class="d-flex align-items-center">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="status"
                      id="aktif"
                      v-model="formData.status"
                      :value="'1'"
                      required
                    />
                    <label class="custom-control-label" for="aktif"
                      >Aktif</label
                    >
                  </div>
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="status"
                      id="tidak_aktif"
                      v-model="formData.status"
                      :value="'0'"
                      required
                    />
                    <label class="custom-control-label" for="tidak_aktif"
                      >Tidak Aktif</label
                    >
                  </div>
                </div>
              </CCol>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
        <Button
          class="btn btn-md btn-success float-right px-4 py-2 mb-3"
          type="submit"
          color="success"
          >Simpan</Button
        >
      </div>
    </form>
  </div>
</template>
<script>
import RplPpakService from "../../../../services/sertifikasi/master-rpl-ppak.service";
import InstrukturRplService from "../../../../services/sertifikasi/master-rpl-instruktur.service";
import LevelService from "../../../../services/datamaster/level.service";
import KotaKabupatenService from "../../../../services/datamaster/kota-kabupaten.service";
import MasterMataUjiService from "../../../../services/sertifikasi/mata-uji.service";
import RplInstrukturService from "../../../../services/sertifikasi/master-rpl-instruktur.service";
import UserGraderService from "../../../../services/sertifikasi/user-grader.service";

import baseUrl from "../../../../services/base-url";
import AutoNumeric from "../../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";

import { AlertUtils } from "../../../../mixins/AlertUtils";
import { MasterDokumen } from "../../../../mixins/master/MasterDokumen";
import MasterRplPpakTambahModel from "./MasterRplPpakTambahModel";

export default {
  mixins: [AlertUtils, MasterDokumen],
  data() {
    return MasterRplPpakTambahModel;
  },
  components: {
    VueAutonumeric,
  },
  mounted() {
    this.getInstrukturRpl();
    this.getLevel();
    this.getMataUji();
    this.getAllDokumen();
    this.getDataPetugasGrader();

    this.baseUrl = baseUrl();
  },
  methods: {
    pilihDokumenPenerbitan(value, k) {
      if(value.idMasterDokumen != null) {
        this.formData.dokumenPersyaratanSertifikat[k].invalid_dokumen = false
      }

      var data = value.idMasterDokumen;

      for (
        let index = 0;
        index < this.formData.dokumenPersyaratanSertifikat.length;
        index++
      ) {

        var idMasterDokumen = this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen;
        var idSelectMasterDokumen = data

        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
          return false;
        }
      }

      this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen = value.idMasterDokumen;
    },
    getDataPetugasGrader() {
      UserGraderService.getUserGrader(0, 1000000000, "default")
        .then((response) => {
          // comment console console.log("INI DATA PETUGAS GRADER");
          // comment console console.log(response);
          this.option_grader = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      var vm = this;
      if (event.idLevelAnggota != null) {
        this.validation.level = false;
        this.formData.idLevel = event.idLevelAnggota;
        // comment console console.log(event.idLevelAnggota);
      } else {
        this.formData.idLevel = "";
      }
    },

    pilihDokumen(value, k) {
      if (value.idMasterDokumen != null) {
        this.formData.dokumenPendukungSertifikasiRplRequest[
          k
        ].invalid_dokumen = false;
        for (
          let index = 0;
          index < this.formData.dokumenPendukungSertifikasiRplRequest.length;
          index++
        ) {
          var idMasterDokumen = this.formData
            .dokumenPendukungSertifikasiRplRequest[index].idMasterDokumen;
          var idSelectMasterDokumen = value.idMasterDokumen;
          if (idMasterDokumen == idSelectMasterDokumen) {
            this.alertError("Tidak Boleh Ada Dokumen Yang Sama");

            return false;
          }
        }
        this.formData.dokumenPendukungSertifikasiRplRequest[
          k
        ].idMasterDokumenPendukung = value.idMasterDokumen;
      } else {
        this.formData.dokumenPendukungSertifikasiRplRequest[
          k
        ].idMasterDokumenPendukung = "";
      }
    },

    pilihMataUji(event, k) {
      if (event.idMasterMataUji != null) {
        this.formData.sertifikasiRplMataUjiRequest[k].invalid_mata_uji = false;
      }

      var data = event.idMasterMataUji;
      for (
        let index = 0;
        index < this.formData.sertifikasiRplMataUjiRequest.length;
        index++
      ) {
        var idMasterMataUji = this.formData.sertifikasiRplMataUjiRequest[index]
          .idMasterMataUji;
        var idSelectMataUji = data;
        if (idMasterMataUji == idSelectMataUji) {
          this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
          return false;
        }
      }
      this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji = data;
      this.formData.sertifikasiRplMataUjiRequest[k].batasNilai =
        event.nilaiMinimum;
      //   document.getElementById("batas_nilai" + k).value = data[1];
      // comment console console.log(k);
    },

    postData() {
      if (this.formData.idLevel == "") {
        var container = this.$el.querySelector("#selectlevel");
        container.scrollIntoView();
        container.focus();
        this.validation.level = true;
        return false;
      } else {
        this.validation.level = false;
      }

      /**
       * Validasi Mata Uji
       */
      var status_invalid = 0;

      this.formData.sertifikasiRplMataUjiRequest.filter(function (
        element,
        index
      ) {
        if (element.idMasterMataUji == "") {
          element.invalid_mata_uji = true;
          status_invalid += 1;
        }
      });

      if (status_invalid > 0) {
        var container = this.$el.querySelector("#divmatauji");
        container.scrollIntoView();
        return false;
      }

      /**
       * Validasi Instruktrur
       */
      var status_invalid_instruktur = 0;

      this.formData.instrukturSertifikasiRplRequest.filter(function (
        element,
        index
      ) {
        if (element.idInstrukturRpl == "") {
          element.invalid_instruktur = true;
          status_invalid_instruktur += 1;
        }
      });

      if (status_invalid_instruktur > 0) {
        var container = this.$el.querySelector("#divinstruktur");
        container.scrollIntoView();
        return false;
      }

      /**
       * Validasi Dokumen
       */
      var status_invalid_dokumen = 0;
      this.formData.dokumenPendukungSertifikasiRplRequest.filter(function (
        element,
        index
      ) {
        if (element.idMasterDokumenPendukung == "") {
          element.invalid_dokumen = true;
          status_invalid_dokumen += 1;
        }
      });

      if (status_invalid_dokumen > 0) {
        var container = this.$el.querySelector("#divdokumen");
        container.scrollIntoView();
        return false;
      }

      this.insertData(this.formData);
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      for (
        let index = 0;
        index < formData.instrukturSertifikasiRplRequest.length;
        index++
      ) {
        for (
          let indexTwo = index + 1;
          indexTwo < formData.instrukturSertifikasiRplRequest.length;
          indexTwo++
        ) {
          if (
            formData.instrukturSertifikasiRplRequest[index].idInstrukturRpl ==
            formData.instrukturSertifikasiRplRequest[indexTwo].idInstrukturRpl
          ) {
            this.alertError("Tidak Boleh Instruktur Yang Sama");

            return false;
          }
        }
      }

      for (
        let mataUji = 0;
        mataUji < formData.sertifikasiRplMataUjiRequest.length;
        mataUji++
      ) {
        for (
          let mataUjiTwo = mataUji + 1;
          mataUjiTwo < formData.sertifikasiRplMataUjiRequest.length;
          mataUjiTwo++
        ) {
          if (
            formData.sertifikasiRplMataUjiRequest[mataUji].idMasterMataUji ==
            formData.sertifikasiRplMataUjiRequest[mataUjiTwo].idMasterMataUji
          ) {
            this.alertError("Tidak Boleh Mata Uji Yang Sama");

            return false;
          }
        }
      }

      for (
        let uploadDok = 0;
        uploadDok < formData.dokumenPendukungSertifikasiRplRequest.length;
        uploadDok++
      ) {
        for (
          let uploadDokTwo = uploadDok + 1;
          uploadDokTwo < formData.dokumenPendukungSertifikasiRplRequest.length;
          uploadDokTwo++
        ) {
          if (
            formData.dokumenPendukungSertifikasiRplRequest[uploadDok]
              .idMasterDokumenPendukung ==
            formData.dokumenPendukungSertifikasiRplRequest[uploadDokTwo]
              .idMasterDokumenPendukung
          ) {
            this.alertError("Kode Dokumen Tidak Boleh Sama");

            return false;
          }
        }
      }

      var vm = this;
      RplPpakService.postRplPpak(formData)
        .then((response) => {
          loader.hide();
          vm.alertSuccess();

          vm.$router.push({
            path: "/sertifikasi/master-sertifikasi-rpl/master-rpl-ppak",
          });
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);

          vm.alertError(error.response.data.message);
        });
    },
    add(index) {
      this.formData.instrukturSertifikasiRplRequest.push({
        instruktur: "",
        invalid_instruktur: false,
        idInstrukturRpl: "",
      });
      // comment console console.log(this.formData.instrukturSertifikasiRplRequest);
    },
    adds(index) {
      this.formData.dokumenPendukungSertifikasiRplRequest.push({
        contoh_dokumen: "",
        kode_dokumen: "",
        nama_dokumen: "",
        fileName: "",
        invalid_dokumen: false,
        idMasterDokumenPendukung: "",
      });
      // comment console console.log(this.formData.dokumenPendukungSertifikasiRplRequest);
    },
    addss(index) {
      this.formData.sertifikasiRplMataUjiRequest.push({
        mata_uji: "",
        keterangan: "",
        nilai: "",
        graderSatu: "",
        graderDua: "",
        invalid_mata_uji: false,
        idMasterMataUji: "",
        modelGraderDua: [],
        modelGraderSatu: [],
      });
      // comment console console.log(this.formData.sertifikasiRplMataUjiRequest);
    },
    remove(index) {
      this.formData.instrukturSertifikasiRplRequest.splice(index, 1);
    },
    removes(index) {
      this.formData.dokumenPendukungSertifikasiRplRequest.splice(index, 1);
    },
    removess(index) {
      this.formData.sertifikasiRplMataUjiRequest.splice(index, 1);
    },

    pilihInstruktur(value, k) {
      if (value.idInstrukturRpl != null) {
        this.formData.instrukturSertifikasiRplRequest[
          k
        ].invalid_instruktur = false;
      }

      for (
        let index = 0;
        index < this.formData.instrukturSertifikasiRplRequest.length;
        index++
      ) {
        var idInstrukturRpl = this.formData.instrukturSertifikasiRplRequest[
          index
        ].idInstrukturRpl;
        var idSelectInstruktur = value.idInstrukturRpl;
        if (idInstrukturRpl == idSelectInstruktur) {
          this.alertError("Tidak Boleh Ada Instruktur Yang Sama");
          return false;
        }
      }

      this.formData.instrukturSertifikasiRplRequest[k].idInstrukturRpl =
        value.idInstrukturRpl;
    },
    getInstrukturRpl() {
      var vm = this;
      RplInstrukturService.getAll()
        .then((response) => {
          vm.instruktur = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    getMataUji() {
      var vm = this;
      MasterMataUjiService.getAllMataUji()
        .then((response) => {
          vm.mataUji = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    getLevel() {
      var vm = this;
      LevelService.getAllLevel()
        .then((response) => {
          vm.levelPeruntukan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    getKotaKab() {
      var vm = this;
      KotaKabupatenService.getAllMataUji()
        .then((response) => {
          vm.idKotaKab = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>